import { render, staticRenderFns } from "./creativeboard.vue?vue&type=template&id=00f1fea6&"
import script from "./creativeboard.vue?vue&type=script&lang=js&"
export * from "./creativeboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports